module.exports = __webpack_public_path__ + "static/media/baag.87b27235.png";